import React, { useState } from 'react'
import { useGameStore } from '../store/gameStore'
import { cardAPI } from '../services/api'
import './TeamBuilder.css'

function TeamBuilder() {
  const { teams, userCards, setTeams, setCurrentTeam, currentTeam, setCurrentPage } = useGameStore()
  const [newTeamName, setNewTeamName] = useState('')
  const [selectedSlots, setSelectedSlots] = useState<number[]>([])
  const [creating, setCreating] = useState(false)

  const handleCreateTeam = async () => {
    if (!newTeamName.trim()) {
      alert('Please enter a team name')
      return
    }

    if (selectedSlots.length !== 6) {
      alert('Please select exactly 6 cards for your team')
      return
    }

    setCreating(true)
    try {
      const response = await cardAPI.createTeam(newTeamName, selectedSlots)
      const newTeams = [...teams, response.data]
      setTeams(newTeams)
      setCurrentTeam(response.data)
      setNewTeamName('')
      setSelectedSlots([])
      alert('Team created successfully!')
    } catch (error) {
      alert('Failed to create team')
    } finally {
      setCreating(false)
    }
  }

  const toggleCardSlot = (cardId: number) => {
    const newSlots = [...selectedSlots]
    const index = newSlots.indexOf(cardId)

    if (index > -1) {
      newSlots.splice(index, 1)
    } else if (newSlots.length < 6) {
      newSlots.push(cardId)
    }

    setSelectedSlots(newSlots)
  }

  const selectTeam = async (team: any) => {
    setCurrentTeam(team)
    await cardAPI.updateTeam(team.id, { is_active: true })
  }

  return (
    <div className="team-builder">
      <div className="builder-header">
        <h2>👥 Team Builder</h2>
      </div>

      <div className="builder-content">
        <div className="team-creation">
          <h3>Create New Team</h3>
          <div className="form-group">
            <input
              type="text"
              placeholder="Team name"
              value={newTeamName}
              onChange={(e) => setNewTeamName(e.target.value)}
              disabled={creating}
            />
          </div>

          <div className="team-slots">
            <div className="slots-info">
              <span>{selectedSlots.length}/6 cards selected</span>
              {selectedSlots.length >= 4 && <span className="ready-badge">Ready for battle!</span>}
            </div>
            <div className="selected-cards">
              {selectedSlots.map((cardId) => {
                const card = userCards.find((c) => c.id === cardId)
                return card ? (
                  <div key={`${cardId}-slot`} className="slot-card">
                    <span>{card.name}</span>
                    <button
                      onClick={() => toggleCardSlot(cardId)}
                      className="remove-btn"
                    >
                      ×
                    </button>
                  </div>
                ) : null
              })}
            </div>
          </div>

          <button
            className="btn-create-team"
            onClick={handleCreateTeam}
            disabled={creating || selectedSlots.length !== 6}
          >
            {creating ? 'Creating...' : 'Create Team'}
          </button>
        </div>

        <div className="team-selection">
          <h3>Your Teams</h3>
          <div className="teams-list">
            {teams.length === 0 ? (
              <p className="empty-state">No teams created yet</p>
            ) : (
              teams.map((team) => (
                <div
                  key={team.id}
                  className={`team-card ${currentTeam?.id === team.id ? 'active' : ''}`}
                  onClick={() => selectTeam(team)}
                >
                  <h4>{team.name}</h4>
                  <p className="card-count">{team.card_slots?.length || 0} cards</p>
                  {currentTeam?.id === team.id && <div className="active-badge">Active</div>}
                </div>
              ))
            )}
          </div>
        </div>

        <div className="card-picker">
          <h3>Available Cards</h3>
          <div className="cards-pool">
            {userCards.map((card) => (
              <div
                key={card.id}
                className={`pool-card ${selectedSlots.includes(card.id) ? 'selected' : ''}`}
                onClick={() => toggleCardSlot(card.id)}
              >
                <div className="card-info">
                  <h5>{card.name}</h5>
                  <span className="attr">{card.attribute}</span>
                </div>
                <div className="card-stats">
                  <span>ATK: {card.base_damage}</span>
                  <span>HP: {card.base_hp}</span>
                </div>
                {selectedSlots.includes(card.id) && <div className="selected-indicator">✓</div>}
              </div>
            ))}
          </div>
        </div>
      </div>

      <button
        className="btn-back"
        onClick={() => setCurrentPage('game-hub')}
      >
        Back to Game Hub
      </button>
    </div>
  )
}

export default TeamBuilder
